import RequiresAuth from '@website/components/auth/RequiresAuth';
import HelpFlow from '@website/components/help/HelpFlow';
import { SalesPopupProvider } from '@website/components/SalesPopupProvider';
import Head from 'next/head';
import { Container } from 'react-bootstrap';

export default function Contact() {
  return (
    <>
      <Head>
        <title>Skyhook: Contact Us</title>
        <meta
          name="description"
          content="Skyhook support. Ask us about a trip. Contact your guide."
        />
      </Head>
      <Container className="mt-4">
        <RequiresAuth
          onSuccess={() => {
            // do nothing
            console.log('onSuccess');
          }}
        >
          <HelpFlow />
        </RequiresAuth>
      </Container>
      <SalesPopupProvider bottomPosition={10} />
    </>
  );
}
